import AxiosService from './AxiosService';

class RestService {

    // Personal Tags
    savePersonalTags(id, data) {
        return AxiosService.post('/pageitems/' + id + '/personal-tags/', data);
    }

    getPersonalTags() {
        return AxiosService.get('/users/personal-tags/');
    }

    removePersonalTag(id) {
        return AxiosService.delete('/personal-tags/' + id);
    }
    
    togglePersonalTags() {
        return AxiosService.put('/personal-tags', {});
    }

    // Favourite Notices
    addFavourite(id) {
        return AxiosService.post('/bookmarks/', { article_id: id });
    }

    removeFavourite(id) {
        return AxiosService.delete('/bookmarks/' + id);
    }

    getFavourites(pageNum) {
        return AxiosService.get('/pageitems/?bookmark=1');
    }

    // Filters
    getFilters() {
        return AxiosService.get('/filters/');
    }

    getFilter(id) {
        return AxiosService.get('/filters/' + id);
    }

    // Latest Feeds/Articles
    getLatestFeeds(options) {
        let search = '';

        for (let key in options) {
            if (options[key] === '') continue;

            const p = search === '' ? '?' : '&';
            search += p + key + '=' + options[key];
        }
        return AxiosService.get('/pageitems/' + search);
    }

    getAdvancedSearch(data) {
        const params = '?page=' + data.page + '&per_page=' + data.per_page;
        return AxiosService.post('/advanced-search/' + params, data);
    }

    getRegulatoryInboxAdvancedSearch(data) {
        const params = '?page=' + data.page + '&per_page=' + data.per_page;
        return AxiosService.post('/advanced-reg-inbox-search/' + params, data);
    }

    getRegulatoryInbox(options) {
        let search = '';

        for (let key in options) {
            if (options[key] === '') continue;

            const p = search === '' ? '?' : '&';
            search += p + key + '=' + options[key];
        }
        return AxiosService.get('/regulatory-inbox/' + search);
    }

    getRegulatoryInboxEnforcements(options) {
        let search = '';

        for (let key in options) {
            if (options[key] === '') continue;

            const p = search === '' ? '?' : '&';
            search += p + key + '=' + options[key];
        }
        return AxiosService.get('/regulatory-inbox-enforcements/' + search);
    }

    getArticleDetails(key) {
        return AxiosService.get('/pageitems/' + key);
    }

    postClickthrough(key, email_ref) {
        return AxiosService.post('/pageitems/' + key + '/clickthrough/');
    }

    getNoticeDetails(key) {
        return AxiosService.get('/regulatory-inbox/' + key);
    }
    
    getArticleCount() {
        return AxiosService.get('/article-count');
    }

    deleteArticle(id) {
        return AxiosService.delete('/pageitems/' + id);
    }
    
    shareArticle(options) {
        return AxiosService.post('/share-notice/', options);
    }
    
    // Users requests
    getColleagues() {
        return AxiosService.get('/colleagues/');
    }
    
    // Send register form
    register(data) {
        return AxiosService.publicPost('/p/registration/', data);
    }

    // Update/change password
    updatePassword(data) {
        return AxiosService.put('/user-change-pwd', data);
    }
    
    // Create a new Regulator
    createRegulator(options) {
        return AxiosService.post('/regulators/', options);
    }
    
    // Update Regulator
    updateRegulator(options, id) {
        return AxiosService.put('/regulators/' + id, options);
    }

    // Get Regulator Details
    getRegulatorDetails(id) {
        return AxiosService.get('/regulators/' + id);
    }

    // Get User Session
    getUserSession(id, page, perPage) {
        return AxiosService.get('/users/session/' + id + '?page=' + (page || 1) + '&per_page=' + perPage, true);
    }

    getUserEventLogs(id, page, perPage) {
        return AxiosService.get('/users/event-logs/' + id + '?page=' + (page || 1) + '&per_page=' + perPage, true);
    }
    
    // Clear all bookmarks
    clearAllBookmarks() {
        return AxiosService.delete('/bookmarks/ALL/');
    }

    // Get Risk Fusion access
    riskFusion() {
        return AxiosService.get('/RiskFusion/AccessCheck/');
    }

    powerBiToken() {
        return AxiosService.get('/powerbi/');
    }

    getAvilableModels() {
        return AxiosService.get('/taxonomy/available-models/');
    }

    setCurrentModel(options) {
        return AxiosService.post('/taxonomy/set-active-model/', options);
    }

    setPreferences(options) {
        return AxiosService.put('/users/preferences/', options);
    }

}

export default new RestService();




// WEBPACK FOOTER //
// ./src/services/REST/RestService.js